import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  Button,
  Col,
  Label,
  Panel,
  Row,
  FormGroup,
  Checkbox
} from 'react-bootstrap'
import autobind from 'autobind-decorator'
import _ from 'lodash'
import moment from 'moment'
import 'moment-range'
import { getAllRooms, updateRoom } from '../redux/actions'
import { EditorRoomName } from '../components/ui/editorComponents'
import {
  changeProgramRoomVisibility,
  changeSearchText
} from '../redux/actions/dashboardActions'
import {
  filteredRoomsSelector,
  programRoomsVisibleSelector,
  searchTextSelector
} from '../redux/selectors/dashboardSelectors'
import Input from '../components/elements/input'

function EditorRow({ room, onChange }) {
  return (
    <tr key={room.id}>
      <td>
        <EditorRoomName room={room} />
      </td>
      <td className={room.edited ? 'edited' : ''}>
        <input
          type='checkbox'
          checked={room.isClean}
          onChange={() => onChange(room)}
        />
      </td>
    </tr>
  )
}

@autobind
class RoomEditorPage extends Component {
  constructor() {
    super()
    this.state = {
      edits: {}
    }
    this.selectedRooms = []
  }

  static propTypes = {
    rooms: PropTypes.object
  }

  componentDidMount() {
    this.props.getAllRooms()
  }

  handleRoomChange(room) {
    this.setState({
      edits: _.set(this.state.edits, `${room.id}.isClean`, !room.isClean)
    })
  }

  handleChangeForAllRooms(event) {
    let { rooms } = this.props
    {
      rooms.map(room =>
        this.setState({
          edits: _.set(this.state.edits, `${room.id}.isClean`, event)
        })
      )
    }
  }

  getNumEdits() {
    return _.size(this.state.edits)
  }

  handleSave() {
    if (this.getNumEdits() === 0) {
      alert("You haven't made any changes")
      return
    }

    let updates = _.map(this.state.edits, (edit, id) => {
      edit.id = id
      return edit
    })

    this.setState({ loading: true })
    this.props
      .updateRoom(updates)
      .then(() => {
        alert('Changes saved successfully')
        this.setState({ edits: {}, loading: false })
      })
      .catch(() => {
        alert('There was an error updating rooms')
        this.setState({ loading: false })
      })
  }

  getRoomsForDisplay() {
    let { rooms } = this.props
    let { edits } = this.state

    let displayRooms = _.chain(rooms)
      .map(room => {
        if (edits[room.id]) {
          room = {
            ...room,
            ...edits[room.id],
            edited: true
          }
        }
        return room
      })
      .value()

    return displayRooms
  }

  render() {
    let {
      programRoomsVisible,
      changeProgramRoomVisibility,
      changeSearchText,
      searchText
    } = this.props
    const { edits, loading } = this.state
    let numEdits = _.size(edits)

    let rooms = this.getRoomsForDisplay()

    return (
      <div className='room-editor'>
        <Panel>
          <div style={{ maxWidth: '40rem', margin: '0 auto' }}>
            <div style={{ border: 'solid 1px gray', padding: '.5rem 1rem' }}>
              <div
                style={{
                  paddingBottom: '1rem',
                  marginBottom: '1rem',
                  borderBottom: 'solid 1px lightgray'
                }}
              >
                <Input
                  type='text'
                  placeholder='Filter Rooms'
                  value={searchText}
                  style={{
                    width: '12rem',
                    display: 'inline-block',
                    marginBottom: 0
                  }}
                  onChange={event => changeSearchText(event.target.value)}
                />
                <FormGroup>
                  <Checkbox
                    checked={programRoomsVisible}
                    onChange={event =>
                      changeProgramRoomVisibility(event.target.checked)
                    }
                    style={{
                      display: 'inline-block',
                      paddingLeft: '1rem',
                      marginBottom: 0
                    }}
                  >
                    Show program rooms
                  </Checkbox>
                </FormGroup>
              </div>
              <div style={{ display: 'flex' }}>
                <span style={{ marginRight: '1rem', alignSelf: 'center' }}>
                  {numEdits} {numEdits === 1 ? 'room' : 'rooms'} will be updated
                </span>
                <Button
                  bsStyle='success'
                  onClick={this.handleSave}
                  disabled={numEdits === 0 || loading}
                  style={{ marginLeft: 'auto' }}
                >
                  {loading ? 'Saving...' : 'Save'}
                </Button>
              </div>
            </div>
            <table className='dashboard-table' style={{ width: '100%' }}>
              <thead>
                <td />
                <td>
                  <FormGroup>
                    <Checkbox
                      onChange={event =>
                        this.handleChangeForAllRooms(event.target.checked)
                      }
                      style={{
                        display: 'inline-block',
                        paddingLeft: '2rem'
                      }}
                    >
                      Is Clean
                    </Checkbox>
                  </FormGroup>
                </td>
              </thead>
              <tbody>
                {rooms.map(room => (
                  <EditorRow room={room} onChange={this.handleRoomChange} />
                ))}
              </tbody>
            </table>
          </div>
          <div style={{ marginTop: '1rem' }} />
        </Panel>
      </div>
    )
  }
}

// Which props do we want to inject, given the global state?
function selectProps(state) {
  let {
    props: { startDate, endDate }
  } = state.dashboard
  return {
    rooms: filteredRoomsSelector(state),
    visits: state.visits,
    guests: state.guests,
    // Create clone of dates so state isn't accidentally mutated
    startDate: moment(startDate),
    endDate: moment(endDate),
    searchText: searchTextSelector(state),
    programRoomsVisible: programRoomsVisibleSelector(state)
  }
}

const mapDispatchToProps = {
  updateRoom,
  getAllRooms,
  changeProgramRoomVisibility,
  changeSearchText
}

// Wrap the component to inject dispatch and state into it
export default connect(
  selectProps,
  mapDispatchToProps
)(RoomEditorPage)



// WEBPACK FOOTER //
// ./src/containers/roomEditorPage.js